/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/virtual_cell.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createComponentVNode } from "inferno";
import { BaseInfernoComponent } from "../../../../core/r1/runtime/inferno/index";
import { renderUtils } from "../../utils/index";
import { HeaderCell } from "./header_cell";
import { OrdinaryCell } from "./ordinary_cell";
export const VirtualCellDefaultProps = {
  width: 0,
  isHeaderCell: false
};
export let VirtualCell = /*#__PURE__*/(() => {
  class VirtualCell extends BaseInfernoComponent {
    render() {
      const {
        colSpan: colSpan,
        isHeaderCell: isHeaderCell,
        className = "",
        width: width,
        styles: styles
      } = this.props;
      const modifiedStyles = renderUtils.addWidthToStyle(width, styles);
      const Cell = isHeaderCell ? HeaderCell : OrdinaryCell;
      return createComponentVNode(2, Cell, {
        className: `dx-scheduler-virtual-cell ${className}`,
        styles: modifiedStyles,
        colSpan: colSpan
      });
    }
  }
  VirtualCell.defaultProps = VirtualCellDefaultProps;
  return VirtualCell;
})();